import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  tableHeader: {
    // Was `grey[100]`. MUI's grey ramp is not type-dependent, so it stayed a
    // light gray band on the dark surface.
    backgroundColor: theme.palette.custom.tableHeaderBackground,
    fontWeight: 'bold',
  },
  iconsCell: {
    display: 'flex',
    gap: theme.spacing(1),
  },
}));

export default useStyles;
